import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useState } from 'react';
import AxiosConfig from '../../../../../config/AxiosConfig';
import b64toBlob from '../../../../helpers/utils/blob';

const OrderCreditNotes = ({ orderDetails }) => {
  const [displayCreditNotes, setDisplayCreditNotes] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDisplayCreditNotes = () => {
    setDisplayCreditNotes(!displayCreditNotes);
  };

  const handleDownload = async (creditNoteId) => {
    setIsLoading(creditNoteId);
    try {
      const response = await AxiosConfig.create(
        'put',
        `/orders/${orderDetails?.reference}/creditNote/${creditNoteId}/pdf`
      )
        .call()
        .getResponseData();

      const content = response?.data;
      if (content && content?.length > 0) {
        const link = document.createElement('a');
        const blobContent = b64toBlob(content, 'application/pdf');
        const blobUrl = URL.createObjectURL(blobContent);
        link.setAttribute('download', response?.filename);
        link.href = `${blobUrl}`;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      {orderDetails?.creditNote?.results?.length ? (
        <Accordion elevation={6} disableGutters expanded={displayCreditNotes}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreRoundedIcon onClick={handleDisplayCreditNotes} />
            }
            sx={{
              userSelect: 'text',
            }}
          >
            <Typography component={'span'} noWrap={true}>
              Factures d&apos;avoir disponibles (
              {orderDetails?.creditNote?.results?.length})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {displayCreditNotes ? (
              <Grid container spacing={2}>
                {orderDetails?.creditNote?.results.map((creditNote, index) => (
                  <Grid key={index} size={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 1,
                      }}
                    >
                      <Box>
                        <Typography variant="subtitle1">
                          {creditNote.reference}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Montant: {creditNote.total_price_ttc}{' '}
                          {getSymbolFromCurrency(creditNote?.currency)}
                        </Typography>
                      </Box>
                      <Button
                        endIcon={
                          isLoading === creditNote.id ? (
                            <CircularProgress size={10} />
                          ) : (
                            <DownloadRoundedIcon />
                          )
                        }
                        sx={{ fontSize: 11 }}
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleDownload(creditNote.id)}
                        disabled={isLoading === creditNote.id}
                      >
                        Télécharger
                      </Button>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="body2" color="text.secondary" align="center">
                Aucune facture d&apos;avoir disponible
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
      ) : null}
    </Box>
  );
};

export default OrderCreditNotes;
